import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  const productLinks = [
    { label: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { label: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
    { label: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
    { label: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  ];

  const guideLinks = [
    { label: 'Guida Completa', url: '/itaobuy-spreadsheet' },
    { label: 'Come Funziona', url: '/come-funziona-itaobuy' },
    { label: 'Guida Principianti', url: '/itaobuy-guida-principianti' },
  ];

  const safetyLinks = [
    { label: 'Sicurezza', url: '/sicurezza' },
    { label: 'Pagamenti', url: '/pagamenti' },
    { label: 'Spedizioni', url: '/spedizioni' },
  ];

  const communityLinks = [
    { label: 'Confronto', url: '/confronto' },
    { label: 'Alternative', url: '/alternative' },
    { label: 'Prezzi', url: '/prezzi' },
  ];

  return (
    <footer className="bg-primary-800 text-background-50">
      <div className="w-full px-6 md:px-10 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left */}
          <div className="flex flex-col gap-6 lg:w-1/3">
            <Link to="/" className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center">
                <span className="text-background-50 font-heading text-sm font-bold">I</span>
              </div>
              <span className="font-heading text-xl font-semibold text-background-50 whitespace-nowrap">
                Itaobuy Spreadsheet
              </span>
            </Link>
            <p className="text-background-50/70 font-body text-sm leading-relaxed max-w-sm">
              {t('footer.tagline')}
            </p>
            {/* Newsletter placeholder */}
            <div className="flex gap-2 max-w-sm">
              <input
                type="email"
                placeholder="La tua email"
                className="flex-1 px-4 py-2.5 rounded-lg bg-background-50/10 border border-background-50/20 text-background-50 placeholder:text-background-50/40 font-body text-sm outline-none focus:border-accent-400 transition-colors"
              />
              <button className="w-10 h-10 rounded-lg bg-accent-500 flex items-center justify-center cursor-pointer hover:bg-accent-400 transition-colors whitespace-nowrap">
                <i className="ri-notification-3-line text-background-50 text-lg"></i>
              </button>
            </div>
          </div>

          {/* Right - Links */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 flex-1">
            <div>
              <h4 className="font-label text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">{t('footer.products')}</h4>
              <div className="flex flex-col gap-2.5">
                {productLinks.map((link) => (
                  <a
                    key={link.label}
                    href={link.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-background-50/60 hover:text-accent-400 font-body text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="font-label text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">{t('footer.guides')}</h4>
              <div className="flex flex-col gap-2.5">
                {guideLinks.map((link) => (
                  <Link
                    key={link.label}
                    to={link.url}
                    className="text-background-50/60 hover:text-accent-400 font-body text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <h4 className="font-label text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">{t('footer.safety')}</h4>
              <div className="flex flex-col gap-2.5">
                {safetyLinks.map((link) => (
                  <Link
                    key={link.label}
                    to={link.url}
                    className="text-background-50/60 hover:text-accent-400 font-body text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <h4 className="font-label text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">{t('footer.community')}</h4>
              <div className="flex flex-col gap-2.5">
                {communityLinks.map((link) => (
                  <Link
                    key={link.label}
                    to={link.url}
                    className="text-background-50/60 hover:text-accent-400 font-body text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-12 pt-8 border-t border-background-50/10">
          <p className="text-background-50/50 font-body text-xs whitespace-nowrap">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/60 hover:text-accent-400 hover:border-accent-400 transition-colors cursor-pointer">
              <i className="ri-global-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/60 hover:text-accent-400 hover:border-accent-400 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/60 hover:text-accent-400 hover:border-accent-400 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/60 hover:text-accent-400 hover:border-accent-400 transition-colors cursor-pointer">
              <i className="ri-telegram-line text-sm"></i>
            </a>
          </div>
          <a href="/privacy" className="text-background-50/50 font-body text-xs hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">
            {t('footer.privacy')}
          </a>
        </div>
      </div>
    </footer>
  );
}